// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-withdrawal-modal-modal_card-IhYBV {
  width: 340px;
  height: initial;
  min-height: 420px;
}

.register-withdrawal-modal-modal_content-Lp6gI {
  padding: 0px 20px;
}

.register-withdrawal-modal-textField_container-WjDIw, .register-withdrawal-modal-dateTime_container-J0Cae {
  width: 100%;
  margin-top: 24px;
}

.register-withdrawal-modal-textField_container-WjDIw:first-child {
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/bank-account/register-withdrawal-modal/register-withdrawal-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".modal_card {\n  width: 340px;\n  height: initial;\n  min-height: 420px;\n}\n\n.modal_content {\n  padding: 0px 20px;\n}\n\n.textField_container, .dateTime_container {\n  width: 100%;\n  margin-top: 24px;\n}\n\n.textField_container:first-child {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `register-withdrawal-modal-modal_card-IhYBV`,
	"modal_content": `register-withdrawal-modal-modal_content-Lp6gI`,
	"textField_container": `register-withdrawal-modal-textField_container-WjDIw`,
	"dateTime_container": `register-withdrawal-modal-dateTime_container-J0Cae`
};
export default ___CSS_LOADER_EXPORT___;
